<template>
  <div v-if="eBookVariation">
    <button
      v-on:click="showDeviceSelectionPopup = true"
      class="btn flip-book-add-to-cart-btn"
      type="button"
    >
      <span class="flip-book-add-to-cart-btn-text">Αγορά ebook</span>
    </button>

    <div
      v-if="showDeviceSelectionPopup"
      class="device-selection-popup"
      ref="deviceSelectionPopup"
    >
      <div class="device-selection-content">
        <span class="device-options-title">Επίλεξε τη συσκευή σου</span>
        <div class="device-options">
          <div class="device-option" @click="handleDeviceSelection('windows')">
            <img src="/ui/main/img/windows-logo.svg" alt="Windows" width="45" height="45" class="img-fluid">
            <span>Windows</span>
          </div>
          <div class="device-option" @click="handleDeviceSelection('android')">
            <img src="/ui/main/img/android-logo.svg" alt="Android" width="55" height="30" class="img-fluid">
            <span>Android</span>
          </div>
          <div v-if="epubAppleLink"
               class="device-option apple"
               @click="handleDeviceSelection('apple')"
               @mouseover="showTooltip"
               @mouseleave="hideTooltip"
          >
            <img src="/ui/main/img/apple-logo.svg"
                 alt="Apple"
                 width="42"
                 height="51"
                 class="img-fluid"
                 @mouseover="showTooltip"
                 @mouseleave="hideTooltip"
            >
            <span @mouseover="showTooltip" @mouseleave="hideTooltip">Apple</span>
            <p class="apple-tooltip">Ευχαριστούμε πολύ. Θα μεταφερθείς στο Apple Store.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import productMixin from './mixins/productMixins'
import onlineMixin from './mixins/onlineMixin'
import cartButtonMixin from './mixins/cartButtonMixin'
import {cloneDeep, flatten, forEach, some} from 'lodash-es'
import { mapActions, mapGetters } from 'vuex'
import store from '../../vue/store'

export default {
  name: 'FlipBookAddToCartBtnEbook',
  mixins: [productMixin, onlineMixin, cartButtonMixin],
  props: {
    productId: {
      type: Number,
      default: null
    },
    showImage: {
      type: Boolean,
      default: true
    },
    showName: {
      type: Boolean,
      default: true
    },
    showContent: {
      type: Boolean,
      default: true
    },
    showQuickView: {
      type: Boolean,
      default: false
    },
    showAddToCart: {
      type: Boolean,
      default: true
    },
    isListing: {
      type: Boolean,
      default: false
    },
    isVariationGroupMaster: {
      type: Boolean,
      default: false
    },
    recommendationType: {
      type: String,
      default: null
    },
    recommendationId: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      version: '0.0.1',
      progress: false,
      productCodeId: null,
      bookVariationId: 1,
      eBookVariationId: 2,
      showDeviceSelectionPopup: false
    }
  },
  mounted () {
    document.addEventListener('click', this.handleClickOutsidePopup)
    this.setProductCodeIdForOneOnOne()
  },
  beforeDestroy () {
    document.removeEventListener('click', this.handleClickOutsidePopup)
  },
  watch: {
    productId () {
      this.setProductCodeIdForOneOnOne()
    }
  },
  computed: {
    ...mapGetters([
      'cartProductCodeQuantity',
      'productCardModal',
      'getRelatedVariationData',
      'getProductById'
    ]),
    ...mapGetters('cartProductCustomizations', ['getSchemaById']),
    quantity () {
      return this.cartProductCodeQuantity(this.eBookProductData?.productCodes[0].productCodeId)
    },
    cartQuantity () {
      return this.cartProductCodeQuantity(this.productCodeId, 0)
    },
    hasAttributes () {
      return some(this.eBookProductData?.productCodes, (e) => {
        return e.productCodeAttributes.length > 0
      })
    },
    hasVariations () {
      return this.eBookProductData?.variations && Object.keys(this.eBookProductData?.variations).length > 0
    },
    hasCustomization () {
      return ('customizationSchemaId' in this.eBookProductData) &&
        this.eBookProductData?.customizationSchemaId !== null &&
        this.getSchemaById(this.eBookProductData?.customizationSchemaId).is_active
    },
    quickViewButtonVisible () {
      return this.productCardModal.open
    },
    stock () {
      return this.eBookProductData?.productStock
    },
    getAttributeIdsWithStock () {
      return flatten(this.eBookProductData?.productCodes
        .filter(item => item.productStock > 0)
        .map(item => item.productCodeAttributes))
    },
    eBookProductData () {
      if (!this.eBookVariation) return null
      const productId = Number(this.eBookVariation.product_id) || Number(this.eBookVariation.productId)
      return this.getProductById(productId)
    },
    currentProductRelatedVariationEntries () {
      const productRelatedVariationEntries = cloneDeep(this.getRelatedVariationData)

      const entries = []
      productRelatedVariationEntries.map(item => {
        forEach(Object.values(item.variations), (variation) => {
          const object = {
            productId: Number(item.product_id),
            variationId: variation.variation_value_id,
            variationGroupId: variation.variation_group_id,
            stock: item.availabilityStock
          }
          entries.push(object)
          return object
        })
      })
      return entries
    },
    eBookVariation () {
      const eBookFromVariations = this.currentProductRelatedVariationEntries.find(variation => Number(variation.variationId) === this.eBookVariationId)
      const eBookProduct = this.isEbook ? this.productData : null
      if (!eBookFromVariations && eBookProduct) return eBookProduct
      if (!eBookFromVariations && !eBookProduct) return null
      const eBookProductId = eBookFromVariations.productId
      return this.getRelatedVariationData.find(product => Number(product.product_id) === eBookProductId)
    },
    isEbook () {
      return this.productData.is_digital === '1'
    },
    epubAppleLink () {
      if (!this.eBookVariation) return null
      return this.eBookVariation.epub_apple_link
    }
  },
  methods: {
    ...mapActions([
      'addToCartClicked'
    ]),
    setProductCodeIdForOneOnOne () {
      if (!this.hasAttributes) {
        this.codeIdChanged(this.eBookProductData?.productCodes[0].productCodeId)
      }
    },
    codeIdChanged (productCodeId) {
      this.productCodeId = productCodeId
    },
    btnBuyClickedEbook () {
      this.progress = true
      this.addToCartClicked({
        productCodeId: this.eBookProductData?.productCodes[0].productCodeId,
        quantity: this.quantity,
        recommendationId: this.recommendationId,
        recommendationType: this.recommendationType
      })
        .then(() => {
          this.progress = false
          this.$emit('modal-close')
        })
    },
    handleDeviceSelection (device) {
      if (device === 'apple') {
        const appleLink = this.epubAppleLink
        if (appleLink) {
          window.open(appleLink, '_blank')
        }
      } else {
        this.btnBuyClickedEbook()
      }
      this.showDeviceSelectionPopup = false
    },
    handleClickOutsidePopup (event) {
      if (this.showDeviceSelectionPopup) {
        const popup = this.$refs.deviceSelectionPopup
        if (popup && !popup.contains(event.target) && !event.target.matches('.flip-book-add-to-cart-btn') && !event.target.matches('.flip-book-add-to-cart-btn-text')) {
          this.showDeviceSelectionPopup = false
        }
      }
    },
    showTooltip (event) {
      const tooltip = event.target.querySelector('.apple-tooltip')
      if (!tooltip) {
        return
      }
      tooltip.style.display = 'block'
    },
    hideTooltip (event) {
      const tooltip = event.target.querySelector('.apple-tooltip')
      if (!tooltip) {
        return
      }
      tooltip.style.display = 'none'
    }
  }
}
</script>

<style lang="scss" scoped>
.flip-book-add-to-cart-btn {
  background: rgb(204, 7, 30) url(../img/cart_icon_white.svg) no-repeat 10px 10px;
  border-radius: 3px;
  display: block;
  padding: 10px 10px 10px 50px;
  color: #ffffff;
  text-decoration: none;
  font-weight: 700;
  font-size: 17px;
  border: unset;
}
.device-selection-popup {
  position: absolute;
  top: 70px;
  left: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  @media screen and (max-width:1199px){
    left:0;
    right:0;
    margin:0 auto;
    max-width: 300px
  }
}

.device-selection-content {
  background: #fff;
  padding: 10px 15px 30px;
  border: 1px solid #231F20;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  gap: 30px;
  max-width:100%;
  width:100%;
  @media screen and (max-width:1199px){
    gap:25px
  }
}

.device-options {
  display: flex;
  align-items: flex-end;
  width: 100%;
  gap: 60px;
  padding-left: 10px;
  padding-right: 10px;
  @media screen and (max-width:991px){
    padding:0;
    gap:25px
  }
}

.device-option {
  cursor: pointer;
  text-align: center;
  width: 100%;
  height: 100%;
  display: grid;
  justify-items: center;
  align-items: center;
  gap: 10px;
  img{
    @media screen and (max-width:991px){
      max-width: 30px
    }
  }
  &.apple {
    &:hover {
      .apple-tooltip {
        display: block !important;
      }
    }
  }
}

.device-options-title {
  color: #231F20;
  font-size: 17px;
  font-weight: 700;
  border-bottom: 1px solid #231F20;
  padding-bottom: 10px;
  text-align: center;
}

.device-option span {
  display: block;
}
.apple-tooltip {
  display: none;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 100%;
  margin-bottom: 10px;
  padding: 10px;
  border-radius: 5px;
  background-color: rgba(0, 0, 0, 0.8);
  color: #fff;
  text-align: center;
  font-size: 12px;
  white-space: pre-wrap;
  z-index: 1000;
  width: 200px;
}
</style>
